import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"

export interface IAcceptCoHostInviteForm {
  name: string
  email: string
  password: string
}

/**
 * Accepts a co-host/transfer ownership invitation by submitting user credentials.
 */
export async function acceptCoHostInvitation(acceptRequest: IAcceptCoHostInviteForm, eventVaultId?: number, token?: string) {
  if (!eventVaultId)
    throw new Error("Missing `eventVaultId` when attempting to accept invite. Please ensure `eventVaultId` is provided.")

  if (!token)
    throw new Error("Missing `token` when attempting to accept invite. Please ensure `token` is provided.")

  const response = await axios.post(`api/${eventVaultId}/invitation/${token}/accept`, acceptRequest)

  return response.data?.Message
}

const ACCEPT_CO_HOST_INVITATION_KEY = "acceptCoHostInvitation"

export function useAcceptCoHostInvitation(eventVaultId?: number, token?: string) {
  return useMutation({
    mutationKey: [ACCEPT_CO_HOST_INVITATION_KEY],
    mutationFn: (acceptRequest: IAcceptCoHostInviteForm) =>
      acceptCoHostInvitation(acceptRequest, eventVaultId, token),
  })
}
